/* eslint react/no-multi-comp: 0 */
import PropTypes from 'prop-types';

import React from 'react';
import ShoppingSearch from '../../search';
import {map, isEmpty} from 'lodash';
import Link from 'react-router/lib/Link';
import ProductListHeroImage from '../hero_image';
import ProductListHeroContent from '../hero_content';
import ShoppingBreadcrumbsBar from '../../breadcrumbs_bar';
import classNames from 'classnames';

const ProductListMobileCondendsedNav = (props) => {
  const { shoppingNavigationItems: { categories, pageTitle }, productList: { campaignBrandingImage, categoryType,
    heroImage, logoImage, openerImages, breadcrumbs, featuredCollectionUrl, featuredCollectionName,
    isShoppingCollectionPageHome, isShoppingHome } } = props;

  const heroImageHtml = (heroImage || !isEmpty(openerImages))
    ? (
      <ProductListHeroImage
        heroImage={heroImage}
        logoImage={logoImage}
        openerImages={openerImages}
        pageTitle={pageTitle}
        categoryType={categoryType}
        brandingBanner={campaignBrandingImage}
        featuredCollectionUrl={featuredCollectionUrl}
        featuredCollectionName={featuredCollectionName}
        isShoppingHome={isShoppingHome}
      />
    )
    : (
      <div className="hero-wrapper">
        <ProductListHeroContent
          pageTitle={pageTitle}
          categoryType={categoryType}
        />
      </div>
    );

  return (
    <div className="product-list-navigation">
      {isShoppingCollectionPageHome && <ShoppingBreadcrumbsBar breadcrumbs={breadcrumbs} />}
      {isShoppingCollectionPageHome && heroImageHtml}
      <div className="shopping-nav condensed">
        <div className={classNames('search-nav', { 'search-nav-centered': isShoppingCollectionPageHome })}>
          <ShoppingSearch/>
        </div>

        <ul>
          {
            map(categories, ({ id, path, name }) =>
              <li key={id}>
                <Link to={path}
                  dangerouslySetInnerHTML={{ __html: name }}
                />
              </li>
            )
          }
        </ul>
      </div>
    </div>
  );
};

ProductListMobileCondendsedNav.propTypes = {
  shoppingNavigationItems: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      path: PropTypes.string,
      is_active: PropTypes.bool,
      name: PropTypes.string
    }))
  }).isRequired,
  productList: PropTypes.shape({
    categoryType: PropTypes.string,
    heroImage: PropTypes.string,
    logoImage: PropTypes.string,
    campaignBrandingImage: PropTypes.string,
    breadcrumbs: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        path: PropTypes.string
      }).isRequired
    ),
    featuredCollectionName: PropTypes.string,
    featuredCollectionUrl: PropTypes.string,
    isShoppingCollectionPageHome: PropTypes.bool
  }).isRequired
};

export default ProductListMobileCondendsedNav;
